<template>
  <div class="dutch-menu-item" :class="{ disabled: dutchMenu.IsPaid }">
    <input
      :id="dutchMenu.Id"
      v-model="dutchMenu.IsChecked"
      type="checkbox"
      class="dutch-menu-item__checkbox"
      hidden
      :disabled="dutchMenu.IsPaid"
    />
    <label :for="dutchMenu.Id" class="dutch-menu-item__label">
      <div class="dutch-menu-item__thumbnail">
        <MenuImage :menu-item="menu" :ad-image-path="menu.ADImagePath" />
      </div>
      <span class="dutch-menu-item__info">
        <span class="dutch-menu-item__name">{{ getNameByLocale(menu) }}</span>
        <span class="dutch-menu-item__price">
          <span>{{ formatCurrency(dutchMenu.TotalPrice) }}</span>
        </span>
      </span>
    </label>
  </div>
</template>

<script lang="ts" setup>
  import MenuImage from '@/components/MenuImage.vue';
  import DutchMenu from '@/interfaces/DutchMenu';
  import { useMenuStore } from '@/stores/menu';
  import { formatCurrency, getNameByLocale } from '@/utils';
  import { computed } from 'vue';

  interface Props {
    dutchMenu: DutchMenu;
  }

  const menuStore = useMenuStore();

  const props = defineProps<Props>();

  const menu = computed(() => {
    return menuStore.getMenu(props.dutchMenu.Data.GroupCode, props.dutchMenu.Data.ItemCode);
  });
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  .dutch-menu-item {
    position: relative;
    border-radius: 0.2239vw;
    box-shadow: vars.$base-box-shadow-black;
    overflow: hidden;
    &.disabled {
      border-color: #dcdcdc;
      background: #cececed1 0% 0% no-repeat padding-box;
      box-shadow: inset 0px 5px 10px #ffffffeb;
      .dutch-menu-item__label {
        opacity: 0.5;
      }
    }
    .dutch-menu-item__checkbox:checked + .dutch-menu-item__label {
      &:before {
        position: absolute;
        top: -0.0746vw;
        left: -0.0746vw;
        width: calc(100% + 0.1493vw);
        height: calc(100% + 0.1493vw);
        border-radius: 0.2239vw;
        border: 0.2985vw solid var(--brand-primary);
        content: '';
      }
      &:after {
        position: absolute;
        top: 0;
        right: 0;
        width: 2.6866vw;
        height: 2.2388vw;
        background: var(--brand-primary) url('@/assets/images/icon-check-white.svg') no-repeat center;
        background-size: 1.6418vw 1.1194vw;
        content: '';
      }
    }
    .dutch-menu-item__label {
      position: relative;
      display: flex;
      padding: 1.3433vw 1.194vw;
      border: 0.0746vw solid #dbdbdb;
      border-radius: 0.2239vw;
    }
    .dutch-menu-item__thumbnail {
      width: 6.4179vw;
      margin-right: 0.8955vw;
    }
    .dutch-menu-item__info {
      display: flex;
      flex-direction: column;
      width: calc(100% - 7.3134vw);
    }
    .dutch-menu-item__name {
      font-size: 1.194vw;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      @media (max-width: vars.$md) {
        font-size: 14px;
      }
    }
    .dutch-menu-item__price {
      display: flex;
      font-size: 1.791vw;
      font-weight: 700;
      margin-top: auto;
    }
  }
</style>
